import React from 'react';

import { useAppSelector } from '../../../components/hooks';
import { LayoutCoordinateVisuals } from '../../../library/layout-geometry/LayoutCoordinateVisuals';
import { getVisibleFeaturePatternContainers } from '../../../store/selectors/layoutDataSelectors';
import { getActiveFeaturePatternContainerMode } from '../../../store/selectors/layoutVisualOptionsSelectors';
import { useAutoInvalidateOnChange } from '../../hooks/invalidation-hooks';
import { useFeaturePatternContainerStyleCalculator } from '../polygon-rendering/common/style';
import { FeaturePatternContainerVisual } from './FeaturePatternContainerVisual';
import { InsertionFeaturePatternContainerVisual } from './InsertionFeaturePatternContainerVisual';

export function FeaturePatternContainersController() {
  const getStyle = useFeaturePatternContainerStyleCalculator();

  const containers = useAppSelector(getVisibleFeaturePatternContainers);
  const renderMode = useAppSelector(getActiveFeaturePatternContainerMode);

  useAutoInvalidateOnChange(renderMode, containers);

  if (renderMode === 'none') return null;

  return (
    <LayoutCoordinateVisuals>
      <InsertionFeaturePatternContainerVisual />

      {containers.map((container) => (
        <FeaturePatternContainerVisual key={container.guid} style={getStyle(container)} container={container} />
      ))}
    </LayoutCoordinateVisuals>
  );
}
